<template>
  <ul :class="$style.logs">
    <li v-for="index in computedCount" :key="index" :class="$style.log">
      <div :class="$style.icon" />
      <div :class="$style.content">
        <div :class="$style.lineLong" />
        <div :class="$style.lineMedium" />
        <div :class="$style.meta" />
      </div>
    </li>
  </ul>
</template>

<script setup lang="ts">
import { computed } from 'vue'

defineOptions({
  name: 'UiSkeletonSquadLogs',
  inheritAttrs: false
})

const props = withDefaults(
  defineProps<{
    count?: number
  }>(),
  {
    count: 4
  }
)

const computedCount = computed(() =>
  props.count && props.count > 0 ? props.count : 4
)
</script>

<style module lang="scss">
@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }

  100% {
    transform: translateX(100%);
  }
}

.shimmerItem {
  position: relative;
  overflow: hidden;
  background: var-default(--skeleton-item-bg);
  border-radius: 0.8em;

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    transform: translateX(-100%);
    background: linear-gradient(
      90deg,
      transparent,
      hsla(0deg, 0%, 100%, 0.35),
      transparent
    );
    animation: shimmer 1.4s infinite;
  }
}

.logs {
  display: flex;
  flex-direction: column;
  gap: 1.2em;
  margin: 0;
  padding: 0;
  list-style: none;
}

.log {
  display: flex;
  gap: 1.6em;
  padding: 1.6em;
  border-radius: 1.2em;
  background: color-get(--root-rgb-bg-tone-light);
  border: 1px solid color-get(--root-rgb-bg-border);
  cursor: wait;
}

.icon {
  width: 3.6em;
  height: 3.6em;
  border-radius: 50%;
  @extend .shimmerItem;
}

.content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.6em;
}

.lineLong {
  width: 80%;
  height: 1.4em;
  border-radius: 0.6em;
  @extend .shimmerItem;
}

.lineMedium {
  width: 60%;
  height: 1.4em;
  border-radius: 0.6em;
  @extend .shimmerItem;
}

.meta {
  width: 30%;
  height: 1em;
  border-radius: 0.4em;
  @extend .shimmerItem;
}
</style>
